var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{class:['loading-icon', {
                'is-absolute-centered': _vm.isAbsoluteCentered,
                'is-in-module-header': _vm.isInModuleHeader
            }]},[_c('svg',{staticClass:"spinner",attrs:{"width":"20px","height":"20px","viewBox":"0 0 66 66","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"path",attrs:{"fill":"none","stroke-width":"6","stroke-linecap":"round","cx":"33","cy":"33","r":"30"}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }